import { render, staticRenderFns } from "./WDebouncedNumberInput.vue?vue&type=template&id=56bec480"
import script from "./WDebouncedNumberInput.vue?vue&type=script&lang=js"
export * from "./WDebouncedNumberInput.vue?vue&type=script&lang=js"
import style0 from "./WDebouncedNumberInput.vue?vue&type=style&index=0&id=56bec480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports